//Starter apis
export const STARTER_API = {
    STARTER_LOGIN: '/ws_an_login.php',
}
export const passwordapi = {
    password: '/ws_an_forgotpass.php',
    getcountrys: '/ws_an_country.php',
    registerdata: '/ws_an_register.php',
    resetpassword:'/ws_an_reset.php',

}

//admin api's
export const adminapi = {
    addashboard: '/ws_an_admindash.php',
    adcharts: '/ws_an_dashboard_charts.php',
    addonors: '/ws_an_donor.php',
    ad_donordocument: '/ws_an_donorview.php',
    ad_funddocument: '/ws_an_fundview.php',
    ad_orgdocument: '/ws_an_orgnisation.php',
    ad_docview: '/ws_an_delete_document.php',
    adfundmanager: '/ws_an_fundmanager.php',
    adorgan: '/ws_an_orgnisation.php',
    adcountry: '/ws_an_country.php',
    adneed: '/ws_an_needtype.php',
    ad_addcountry: '/ws_an_addcountry.php',
    ad_addneed: '/ws_an_addneedtype.php',

}

//Donor api's
export const donorapi = {
    ddashboard: '/ws_an_donordashboard.php',
    orgtranscript:'/ws_an_getdonorcountrynyid.php',
    dorgtranscript:'/ws_an_donor_org_donations.php',
    dcharts: '/ws_an_dashboard_charts.php',
    durgentneed: '/ws_an_newsletters.php',
    dneeds: '/ws_an_orgneeds.php',
    dview: '/ws_an_donorlistview.php',
    dneedprofile: '/ws_an_needview.php',
    dviewtable: '/ws_an_donorneedview.php',
    donation: '/ws_an_donordonations.php',
    document: '/ws_an_documents.php',
    feedbacks: '/ws_an_feedback.php',
    country: '/ws_an_needtype.php',
    orgs:'/ws_an_org_allneeds.php',
    search: '/ws_an_searchorg.php',
    donorchat: '/ws_an_applicationcommunication.php',
    msg: '/ws_an_entermessage.php',
    deletedocument: '/ws_an_delete_document.php',
    headerprofile:'/headerprofile.php',
    adddocuments: '/ws_an_adddocument.php',
    docfile: '/ws_an_filetoupload.php',
    Addfeeds: '/ws_an_feedbackdetails.php',
    addsfeed: '/ws_an_addfeedback.php',
    fundmanager: '/ws_an_donorfund.php',
    fundreports: '/ws_an_getdonorcountrynyid.php',
    fundtranscript: '/ws_an_donor_fund_donationsdetails.php',
    donorprofile:'/ws_an_donorinfo.php',
    dprofileimage:'/ws_an_profileupload.php',
    dprofiledata:'/ws_an_donorprofile.php',
    dregdata:'/ws_an_donorprofile.php'

}

//fundmanager api's
export const fundmanagerapi = {
    fmdashboards: '/ws_an_fundmanager_dashboard.php',
    fmcharts: '/ws_an_dashboard_charts.php',
    fmdonations: '/ws_an_donations_list_dash.php',
    orgapps: '/ws_an_servicing.php',
    fmdocument: '/ws_an_documents.php',
    fundfeedbacks: '/ws_an_feedback.php',
    fmdonationslist: '/ws_an_fundlist.php',
    fmdonorreports: '/ws_an_funddonorreports.php',
    fmorgreports: '/ws_an_fundorgreports.php',
    fmaddfeedbacks: '/ws_an_feedbackdetails.php',
    adddocument: '/ws_an_adddocument.php',
    viewdocuments: '/ws_an_delete_document.php',
    uploadimages: '/ws_an_filetoupload.php',
    viewapplication: '/ws_an_orgapplicationdetails.php',
    orgapplication: '/ws_an_chat_data.php',
    fundapplication: '/ws_an_donorview.php',
    messagetype: '/ws_an_entermessage.php',
    approvedata: '/ws_an_donorview.php',
    deletedocuments: '/ws_an_delete_document.php',
    adddata: '/ws_an_addfeedback.php',
    genarate: '/ws_an_getcountrynyid.php',
    fdonorreports:'/ws_an_fund_donar_donationsdetails.php',
    organizationreports :'/ws_an_fund_org_donations.php',
    donationslist:'/ws_an_select_org_details.php',
    dprofile    :'/ws_an_fund_info.php',
     viewdocumentdata:'/ws_an_documents.php',
    uploadimage       :'/ws_an_fundprofileupload.php',
    editprofile :'/ws_an_fundprofile.php',

}

//Organization api's
export const orgapi = {
    orgdashboard: '/ws_an_orgdashboard.php',
    orgdashcharts: '/ws_an_dashboard_charts.php',
    orgdashlist: '/ws_an_donations_list_dash.php',
    orgnizationneeds: '/ws_an_org_needs.php',
    orgdonations: '/ws_an_received_donations.php',
    orgdocuments: '/ws_an_documents.php',
    orgfeedbacks: '/ws_an_feedback.php',
    orgapplications: '/ws_an_org_applications_list.php',
    orgdonreports: '/ws_an_org_donorreports.php',
    orgfundreports: '/ws_an_donorfund.php',
    orgaddfeedback: '/ws_an_feedbackdetails.php',
    orgcountry: '/ws_an_country.php',
    orgsaerchfund: '/ws_an_searchfundman.php',
    organizationaddneeds: '/ws_an_addneed.php',
    orgdocview: '/ws_an_delete_document.php',
    orgneedprofile: '/ws_an_needview.php',
    orgneedtable: '/ws_an_donorneedview.php',
    orgneedview: '/ws_an_donorlistview.php',
    orgapplication: '/ws_an_applyapplication.php',
    orgviewapplication: '/ws_an_orgapplicationdetails.php',
    orgsaveapp: '/ws_an_saveorgapplication.php',
    orgdeldata:'/ws_an_delete_document.php',
    orgdchat:'/ws_an_applicationcommunication.php',
    orgdmsg:'/ws_an_entermessage.php',
    orgadddoc:'/ws_an_adddocument.php',
    orgaddfile:'/ws_an_filetoupload.php',
    orgaddfeedbacks:'/ws_an_addfeedback.php',
    orgfunreport:'/ws_an_getorgcountrynyid.php',
    orgfungen:'/ws_an_org_fund_donations.php',
    orgfeedtype:'/ws_an_feedbackdetails.php',
    orgapplyapp:'/ws_an_orgapplicationreapply.php',
    orgchat:'/ws_an_chat_data.php',
    orgmessage:'/ws_an_entermessage.php',
    orgdonrep:'/ws_an_org_donor_donationsdetails.php',
    orgprofile:'/ws_an_org_profile.php',
    orgprofileimg:'/ws_an_orgprofileupload.php',
    orgprofiledata:'/ws_an_orgprofile.php',
    orgdon:'/ws_an_invoice.php',
}
//mobile api's
export const mobileapi = {
    mobidashboard:'/anddonations.php',
    mobapp:'/andusertype.php',
    mobdash:'/anddashboard.php',
    mobcol:'/ws_an_dashboard_charts.php',
    moblist:'/ws_an_donations_list_dash.php',
}


